import React from "react";


function AI()
{
    return (
        <div>
            <h2>AI bots</h2>
            <div class="row">
                <div class="col-6">
                    <ul>
                        <li><a href="https://chatgpt.com">ChatGPT</a></li>
                        <li><a href="https://claude.ai/">Claude.ai</a></li>
                        <li><a href="https://www.perplexity.ai/">Perplexity</a></li>
                        <li><a href="https://chat.mistral.ai/chat">Mistral AI</a></li>
                        <li><a href="https://gemini.google.com/">Gemini</a></li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default AI;